// extracted by css-extract-rspack-plugin
export default {"barTooltipLabel":"barTooltipLabel-suF_rY","barTooltipValue":"barTooltipValue-WONd5h","barTooltipValueNoData":"barTooltipValueNoData-zlniLS","highlight":"highlight-Mz8CtL"};